import React from 'react';
import classNames from 'classnames';
interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
	label?: string;
}

const Checkbox = React.forwardRef<HTMLInputElement, IProps>((props, ref) => {
	const { label, className, ...otherProps } = props;
	return (
		<div className={classNames('form-check', className)}>
			<label className="form-check-label" htmlFor={props.id}>
				<input ref={ref} className="form-check-input" type="checkbox" {...otherProps} />
				{label}
			</label>
		</div>
	);
});

export default Checkbox;